const map = (list) => {
    const wrapper_centers = document.querySelector('[data-centers]');
    
    if (!wrapper_centers) return;

    const marker = {
        iconLayout: 'default#image',
        iconImageHref: '/img/marker.svg',
        iconImageSize: [40, 40]
    };

    ymaps.ready(init);
    function init() {
        var map = new ymaps.Map("map", {
            center: [56.448897, 84.973367],
            zoom: 7
        });

        list.forEach(element => {
            let name= element.examinationAreaAddress;    

            if (element.latitude && element.longitude) {
                let placemark = new ymaps.Placemark([element.latitude, element.longitude], {
                    balloonContent: `
                        <div class="balloon">
                            <h4>Центр тестирования в&nbsp;г.&nbsp;${name.split(',')[0]}</h4>
                            <div class="balloon-blocks">
                                <div class="balloon-block">
                                    <p><strong>Экзаменационная площадка:</strong></p>
                                    ${element.examinationAreaFullName ? `<p>${element.examinationAreaFullName}</p>` : ''}
                                    ${element.linkToProcessingPersonalData ? `<a href="${element.linkToProcessingPersonalData}" class="balloon-buttons__link" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a>` : ''}
                                </div>
                                <div class="balloon-block">
                                    <p><strong>Адрес места проведения экзамена:</strong></p>
                                    <p>г. ${name}${element.additionalAddressInfo ? `, ${element.additionalAddressInfo}` : ''}</p>
                                </div>
                                <div class="balloon-block">
                                    <p><strong>Часы работы:</strong></p>
                                    ${element.openingHours ? `<p>${element.openingHours}</p>` : ''}
                                </div>
                                <div class="balloon-block">
                                    <p><strong>Контакты:</strong></p>
                                    ${element.contactPhone ? `<p>Телефон: <a href="tel:${element.contactPhone}">${element.contactPhone}</a></p>` : ''}
                                    ${element.contactEmail ? `<p>E-mail: <a href="mailto:${element.contactEmail}">${element.contactEmail}</a></p>` : ''}
                                </div>
                            </div>
                            <div class="balloon-buttons">
                                ${element.isRemoteSubmissionAvailable ? 
                                    `<a href="#form" data-close-modal class="btn" data-area="${element.examinationAreaId}">Записаться</a>` : 
                                    '<button data-close-modal disabled class="btn">Записаться</button>'
                                }
                                <a href="/area?id=${element.examinationAreaId}" target="_blank" class="btn-white">Смотреть расписание экзаменов</a>                                                         
                            </div>
                        </div>
                    `
                }, marker);
                
                map.geoObjects.add(placemark);
            }
        });  
    }
}

export default map;